import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store';
import 'remixicon/fonts/remixicon.css';


Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

//API
import axios from 'axios';
import VueAxios from 'vue-axios';
//Vue.prototype.$hostUrl = 'https://21century.ipst.ac.th/';
Vue.prototype.$hostUrl = 'https://academic.skw.ac.th/alumni/';
//Vue.prototype.$hostUrl = 'https://electa.in.th/PISA_api/';
Vue.use(VueAxios, axios);

//COOKIES
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
// set default config
Vue.$cookies.config('1d');


//KONVA
import VueKonva from 'vue-konva';
Vue.use(VueKonva);





new Vue({
    el: '#app',
    router,
    store,
    icons,
    template: '<App/>',

    components: {
        App
    }
})